<template>
  <Transition name="vendor-group-modal-overlay">
    <div
      v-if="visible"
      class="vendor-group-modal-overlay vendor-group-modal-overlay--glass"
      @click.self="$emit('cancel')"
    >
      <Transition name="vendor-group-modal-panel" appear>
        <div
          v-if="visible"
          class="vendor-group-modal-card vendor-group-modal-card--glass"
          role="dialog"
          aria-modal="true"
          aria-labelledby="vendor-group-modal-title"
          @click.stop
        >
          <div class="vendor-group-modal-header vendor-group-modal-header--glass">
            <h2 id="vendor-group-modal-title" class="vendor-group-modal-title">
              Vendor Group
            </h2>
            <button
              type="button"
              class="vendor-group-modal-close-btn"
              aria-label="Close"
              title="Close"
              @click="$emit('cancel')"
            >
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>

          <div class="vendor-group-modal-body vendor-group-modal-body--glass">
            <LabelInputField
              input-id="vendor-group-name"
              label="Name"
              v-model="groupName"
              placeholder="e.g. 1099 Vendors"
              required
              flex
              :has-error="!!error"
              :disabled="saving"
              @input="error = ''"
            >
              <div v-if="error" class="vendor-group-modal-error">{{ error }}</div>
            </LabelInputField>
          </div>

          <div class="vendor-group-modal-actions vendor-group-modal-actions--glass">
            <SecondaryButton label="Cancel" :disabled="saving" @click="$emit('cancel')" />
            <PrimaryButton label="Save" :loading="saving" @click="ok" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>

  <ErrorModal
    :show="showErrorModal"
    title="Validation Error"
    :message="errorMessage"
    buttonText="OK"
    @close="closeErrorModal"
  />
</template>

<script>
import '../styles/AddNewVendorGroup.css';
import CompanyService from '@/services/company.service.js';
import ErrorModal from '@/components/ErrorModal.vue';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'AddNewVendorGroup',
  components: {
    ErrorModal,
    LabelInputField,
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      groupName: '',
      error: '',
      saving: false,
      showErrorModal: false,
      errorMessage: '',
    };
  },
  methods: {
    async ok() {
      if (!this.groupName.trim()) {
        this.error = 'Name field is required.';
        return;
      }
      this.saving = true;
      this.error = '';
      try {
        const group = await CompanyService.createVendorGroup({
          name: this.groupName.trim(),
          companyId: this.companyId,
        });
        this.$emit('ok', group);
        this.groupName = '';
        this.error = '';
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message || err.message || 'Failed to create vendor group.';
        this.showErrorModal = true;
      } finally {
        this.saving = false;
      }
    },

    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
  },
};
</script>
